import { defineComponent as _defineComponent } from 'vue'
import TUIChatEngine, {
  TUIStore,
  StoreName,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import {
  ref,
} from "../../../adapter-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isNotNetwork = ref(false);

TUIStore.watch(StoreName.USER, {
  netStateChange: (value:string) => {
    const disconnected = value === TUIChatEngine.TYPES.NET_STATE_DISCONNECTED;
    const connecting = value === TUIChatEngine.TYPES.NET_STATE_CONNECTING;
    return isNotNetwork.value = disconnected || connecting;
  },
})

return { __sfc: true,isNotNetwork, TUITranslateService }
}

})